export default __webpack_public_path__ + "static/media/subject-code-blue.8cbece66.svg";